<template>
  <div class="geo-rules-editor">
    <div class="d-flex align-center">
      <span class="font-weight-medium mr-4" style="width: 200px">Geo</span>
      <span class="font-weight-medium">Device Type</span>
      <v-btn text color="success" class="ml-auto" small :disabled="readonly" @click="$emit('add')">
        <v-icon left small>mdi-plus-circle-outline</v-icon>
        Add rule
      </v-btn>
    </div>

    <div
      v-for="(rule, index) in rules"
      :key="index"
      class="d-flex align-end mb-4"
    >
      <div class="mr-4" >
        <span class="caption grey--text">Visitor Geo:</span>
        <select-countries
          :chosen-countries="rule.geo"
          :countries="allCountries"
          :disabled="readonly"
          :multiple="false"
          :outlined="false"
          @input="(items) => $emit('update:geo', { index, value: items.value })"
        />
      </div>

      <div style="max-width: 200px" class="flex-grow-1 pa-0 mr-4">
        <div class="caption grey--text">Device</div>
        <v-select
          :value="rule.devices"
          :items="deviceTypes"
          :disabled="readonly"
          item-text="text"
          item-value="value"
          multiple
          dense
          hide-details
          class="device-type_select"
          @input="(val) => $emit('update:devices', { index, value: val })"
        >
          <template #selection="{ item, index: i }">
            <v-chip v-if="i === 0" small outlined color="primary">{{ item.text }}</v-chip>
            <span v-if="i === 1" class="grey--text text-caption ml-1">
              (+{{ rule.devices.length - 1 }})
            </span>
          </template>
        </v-select>
      </div>

      <v-btn icon color="error" :disabled="readonly" @click="$emit('remove', index)">
        <v-icon small>mdi-minus-circle-outline</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
  import SelectCountries from '@/components/core/SelectCountries.vue'
  import { allCountries } from '@/components/core/SelectLang/mapperIsoLocale'
  import { DEVICE_TYPES } from '@/modules/mirrors-redirectors/constants/const'

  export default {
    name: 'GeoRulesEditor',
    components: { SelectCountries },
    props: {
      rules: {
        type: Array,
        default: () => [],
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        allCountries,
        deviceTypes: DEVICE_TYPES,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .geo-rules-editor {
    .device-type_select {
      & ::v-deep span {
        margin: 0 4px 0 0;
      }
    }
  }
</style>
